const doorWindowFitterService = {
  title: "Door / Window Fitter",
  icon: "🚪",
  shortDescription:
    "Door fitting, window alignment, lock support, hinges, channels, and frame adjustment.",
  longDescription:
    "Book door and window fitting support for alignment, fitting, repairs, and minor hardware issues.",
  consultationNote:
    "Replacement-heavy or frame modification jobs may need inspection before final quote.",
  responsePromise:
    "Assignment depends on fitting type, structure condition, and local specialist availability.",
  warrantyPolicy:
    "Support depends on existing structure, hardware, and job type.",
  subServices: [
    {
      id: "door-lock-fit",
      title: "Door Lock Fitting",
      icon: "🔐",
      group: "Doors",
      description:
        "Fit or replace lock, latch, or small hardware in door systems.",
      basePrice: 249,
      priceType: "fixed",
      duration: "30-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "door-hinge-fit",
      title: "Door Hinge Fitting",
      icon: "🪛",
      group: "Doors",
      description:
        "Install or replace hinge support for smooth door operation.",
      basePrice: 199,
      priceType: "fixed",
      duration: "20-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "window-alignment-fix",
      title: "Window Alignment Fix",
      icon: "🪟",
      group: "Windows",
      description:
        "Adjust alignment, stopper, or fitting issue in window panel systems.",
      basePrice: 299,
      priceType: "starts_at",
      duration: "30-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "door-window-inspection",
      title: "Door / Window Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for replacement, fitting, frame issue, or estimate planning.",
      basePrice: 299,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default doorWindowFitterService;